<template>
  <div v-if="value" class="overlay" @click.self="close">
    <div class="popup" :style="popupBackground">
      <img style="height: 64px; margin-bottom: 16px" :src="logo" alt="Logo" />

      <p v-if="message">{{ message }}</p>

      <p v-if="html" v-html="html" style="padding: 0px 10px"></p>

      <button
        style="width: 80%; margin-bottom: 12px; font-weight: bold; height: 50px"
        :style="{ backgroundColor: buttonColor, color: buttonTextColor }"
        @click="close"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimplePopup',
  props: {
    value: { type: Boolean, default: false },
    logo: { type: String },
    message: { type: String, default: null },
    html: { type: String, default: null },
    bgImg: { type: String, default: null },
    gradient: {
      type: String,
      default: 'linear-gradient(to bottom, #000, #222, #444)',
    },
    buttonColor: { type: String, default: '#000000' },
    buttonTextColor: { type: String, default: '#FFFFFF' },
    buttonText: { type: String },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
  computed: {
    popupBackground() {
      if (this.bgImg) {
        return {
          backgroundImage: `url(${this.bgImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }
      }
      if (this.gradient) {
        return {
          background: this.gradient.replace(/;$/, ''),
        }
      }
      return ''
    },
  },
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.popup {
  background: white;
  padding: 40px 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  min-width: 250px;
  max-width: 550px;
}

.popup button {
  margin-top: 15px;
  padding: 8px 16px;
  background: black;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.popup button:hover {
  background: #333;
}
</style>
